import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import {
    ApiBlueprint,
    discoveryApiRef,
    fetchApiRef,
} from '@backstage/frontend-plugin-api';
import { isAwsSecurithHubFindingsAvailable } from '../components/Router';
import { awsSecurityHubApiRef, AwsSecurityHubApiClient } from '../api';
import { rootRouteRef } from '../routes';

export const securityHubContentExtension = EntityContentBlueprint.make({
    name: 'securityhub',
    params: {
        path: '/security-hub',
        title: 'Security Hub',
        routeRef: rootRouteRef,
        filter: isAwsSecurithHubFindingsAvailable,
        loader: async () =>
            import('../components/Router').then((m) =>
                <m.Router />
            ),
    },
});


export const securityHubApi = ApiBlueprint.make({
    name: 'securityhub',
    params: (defineParams: any) =>
        defineParams({
            api: awsSecurityHubApiRef,
            deps: {
                discoveryApi: discoveryApiRef,
                fetchApi: fetchApiRef
            },
            factory: ({
                discoveryApi,
                fetchApi,
            }: any) =>
                new AwsSecurityHubApiClient({ discoveryApi, fetchApi }),
        }),
});